import {routes} from './noticia.routes';
import NoticiaListController from "./directory/directory.controller";
import NoticiaService from "./noticia.service";
import NoticiaDetailsController from "./details/details.controller";
import NoticiaCreateNoticiaController from "./new/new.controller";
import NoticiaFileUploaderController from "./details/files.dialog.controller";

export default angular.module('app.noticia', [])
  .config(routes)
  .controller('NoticiaListController', NoticiaListController)
  .service('NoticiaService', NoticiaService)
  .controller('NoticiaDetailsController', NoticiaDetailsController)
  .controller('NoticiaCreateNoticiaController', NoticiaCreateNoticiaController)
  .controller('NoticiaFileUploaderController', NoticiaFileUploaderController)
  .name;
